import {
  PictureAsPdfRounded,
  TableChartRounded,
  DescriptionRounded,
  ArticleRounded,
  ImageRounded,
  InsertDriveFileRounded,
} from '@mui/icons-material';
import { getFileCategory, FileCategory } from './types';

const ICON_BY_CATEGORY: Record<FileCategory, { Icon: typeof PictureAsPdfRounded; color: string }> = {
  pdf: { Icon: PictureAsPdfRounded, color: '#C62828' },
  excel: { Icon: TableChartRounded, color: '#1E7E34' },
  doc: { Icon: DescriptionRounded, color: '#1B5FBD' },
  md: { Icon: ArticleRounded, color: '#5C5C5C' },
  image: { Icon: ImageRounded, color: '#8E24AA' },
};

interface Props {
  filename: string;
  fontSize?: number;
}

const DocFileIcon = ({ filename, fontSize = 16 }: Props) => {
  const category = getFileCategory(filename);
  const { Icon, color } = category ? ICON_BY_CATEGORY[category] : { Icon: InsertDriveFileRounded, color: '#9E9E9E' };
  return <Icon sx={{ fontSize, color }} />;
};

export default DocFileIcon;
